import { render, staticRenderFns } from "./Grid.vue?vue&type=template&id=5652bfea&scoped=true&"
import script from "./Grid.vue?vue&type=script&lang=js&"
export * from "./Grid.vue?vue&type=script&lang=js&"
import style0 from "./Grid.vue?vue&type=style&index=0&id=5652bfea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5652bfea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItem } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VListItem,VTextField})
